import React, {Component} from 'react';
import './Header.css';
import strings from "../strings";

export class Header extends Component {
  render() {
    return (
      <header>
        <div className="logo"><img src="/logo.svg" alt="Sundström"/></div>
        <div className="title"><span>{strings.title}</span></div>
      </header>
    );
  }
}
